export function BrandBadge({ 
  text = "Made Local",
  fontSize = 22 
}: { 
  text?: string; 
  fontSize?: number; 
}) {
  return (
    <div 
      className="inline-block"
      style={{ 
        transform: 'rotate(-1.7deg)', 
      }}
    >
      <span 
        style={{
          fontSize: `${fontSize}px`,
          fontWeight: 400,
          fontFamily: 'Pacifico, cursive',
          letterSpacing: '0.8px',
          background: 'linear-gradient(to right, #FF9800, #FF5722)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          filter: 'drop-shadow(0 4px 10px rgba(255, 152, 0, 0.4))',
          display: 'inline-block',
          padding: '0 4px',
        }}
      >
        {text}
      </span>
    </div>
  );
}